import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ShiftCalendarFeature } from "@/features/shift-calendar";

const searchSchema = z.object({
  clientId: z.coerce.number().optional(),
  siteId: z.coerce.number().optional(),
  categoryId: z.coerce.number().optional(),
  guardUserId: z.coerce.number().optional(),
  shiftType: z.string().optional(),
  fromDate: z.string().optional(),
  view: z.enum(["month", "day", "list", "week"]).optional(),
});

function ShiftCalendarPage() {
  const search = Route.useSearch();
  return (
    <ShiftCalendarFeature
      clientId={search.clientId}
      siteId={search.siteId}
      categoryId={search.categoryId}
      guardUserId={search.guardUserId}
      shiftType={search.shiftType}
      fromDate={search.fromDate}
      view={search.view}
    />
  );
}

export const Route = createFileRoute("/scheduler/")({
  component: ShiftCalendarPage,
  staticData: { authorize: true },
  validateSearch: searchSchema,
});
